/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 *
 * PERFORMANCE NOTE (2026-07-19): All pages except "Home" were moved out of this
 * eager-import registry into src/RouterConfig.jsx's lazy-loaded manifestRoutes.
 * Every page listed here is statically imported into the app's initial bundle —
 * fine for a single landing page, but with 30+ entries it meant every visitor
 * (including anonymous mobile homepage traffic) downloaded the full weight of
 * every admin/dashboard page (some 100KB+) before first paint. PageSpeed Insights
 * flagged this as ~524 KiB of unused JavaScript on mobile. If you add a new page
 * here via the Base44 editor, consider moving it to RouterConfig.jsx's lazy
 * pattern (see the "Lazy-loaded pages" section there) unless it must be eager
 * (i.e. it IS the landing page).
 */
import Home from './pages/Home';
import __Layout from './Layout.jsx';


export const PAGES = {
    "Home": Home,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};